module.exports = "/virtual-football-league/img/amblems/right/logos/AtleticoMadrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/AtleticoMadrid.png
// module id = 2157
// module chunks = 4